import React from 'react'
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'
import { DefaultColumnFilter } from '../components/elem/Grid/GridSearch'
import {
    Cell,
    NoteCell,
    ActionCell,
    InfoCell,
} from '../components/elem/Grid/Cells'

const tableColumns = (process) => {
    const columns = Object.keys(process)
        .map((col) => {
            const columnFilter =
                process[col].DataType === 'Number'
                    ? {
                          Filter: DefaultColumnFilter,
                          filter: 'equals',
                            width: 110,
                      }
                    : process[col].DataType === 'String' &&
                      process[col].Label !== 'Communication'
                    ? { Filter: DefaultColumnFilter, filter: 'text', width: 120 }
                    : {
                          canFilter: false,
                          disableFilters: true,
                           width: 110
                      }

            return {
                ...columnFilter,
                Header: process[col].Label,
                accessor: col,
                Cell: ({ cell, column, row }) => (
                    <Cell
                        value={cell.value}
                        type={process[col].DataType}
                        column={column.id}
                        row={row}
                    />
                ),
            }
        })
        .map((item) => {
            if (item.accessor === 'LastAction') {
                item.accessor = 'StartDate'
            }
            if (item.accessor === 'RecordId') {
                item.accessor = 'ExternalDataItemId'
                item.width = 90
            }
            if (item.accessor === 'Status') {
                item.accessor = 'StateName'
            }
            if (item.accessor === 'LastNoteDate') {
                item.width = 130
            }
            if (item.accessor === 'NoteSummary') {
                item.width = 160
            }
            if (item.accessor === 'ActionGroup') {
                item.width = 90
            }
            return item
        })

    const fixedColumns = [

        {
            Header: () => null,
            id: 'expander',
            filterable: false,
            disableFilters: true,
            disableResizing: true,
            sortable: false,
            width: 30,
            Cell: ({ row }) => {
                return (
                    <span
                        {...row.getToggleRowExpandedProps()}
                        style={{
                            color: 'inherit',
                            verticalAlign: '-webkit-baseline-middle',
                            paddingTop: '1px',
                        }}
                    >
                        {row.isExpanded ? <FaCaretDown /> : <FaCaretRight />}
                    </span>
                )
            },
            SubCell: () => null,
        },
        {
            Header: '',
            accessor: 'AttributeJSON',
            disableFilters: true,
            width: 30,
            filterable: false,
            disableSortBy: true,
            disableResizing: true,
            sortable: false,
            Cell: ({ row }) => (
                <InfoCell
                    attributes={row.original.AttributeJSON}
                    id={row.original.ExternalDataItemId}
                />
            ),
        },
        {
            Header: 'Actions',
            accessor: 'StateId',
            disableFilters: true,
            filterable: false,
            sortable: false,
            width: 200,
            Cell: ({ row }) => (
                <ActionCell
                    stateId={row.original.StateId}
                    externalDataItemId={row.original.ExternalDataItemId}
                    maxDuration={row.original.StateMaxDurationDays}
                    row={row}
                />
            ),
        },
        {
            Header: '',
            accessor: 'ExternalDataItemId',
            disableFilters: true,
            width: 30,
            filterable: false,
            disableResizing: true,
            sortable: false,
            id: 'note',
            Cell: ({ row }) => (
                <NoteCell id={row.original.ExternalDataItemId} />
            ),
        },
    ]

    return fixedColumns.slice(0, 1).concat(columns, fixedColumns.slice(1))
}

export default tableColumns
